import { LlmApiError, PROVIDER_LABELS, type Provider } from '../core/llm.js'

export interface FriendlyError {
  message: string
  needsSettings: boolean
}

function apiLabel(provider: Provider): string {
  return `${PROVIDER_LABELS[provider]} API`
}

export function friendlyErrorMessage(err: unknown): FriendlyError {
  if (err instanceof LlmApiError) {
    const label = apiLabel(err.provider)
    if (err.status === 400 && /api key not valid/i.test(err.message)) {
      return {
        message: `APIキーが無効です。「設定」から正しい${label}キーを設定してください。`,
        needsSettings: true,
      }
    }
    if (err.status === 400 && err.message.includes('モデルID')) {
      return { message: err.message, needsSettings: true }
    }
    if (err.status === 400) {
      return {
        message: `${label}がリクエストを拒否しました: ${err.message}`,
        needsSettings: false,
      }
    }
    if (err.status === 401 || err.status === 403) {
      return {
        message: `APIキーが無効か、権限がありません。「設定」から${label}キーを確認してください。`,
        needsSettings: true,
      }
    }
    if (err.status === 404) {
      return {
        message: '指定したモデルが見つかりません。「設定」でモデルを変更してください。',
        needsSettings: true,
      }
    }
    if (err.status === 429) {
      return {
        message:
          'APIのレート制限に達しました。しばらく待ってから再送信するか、別のモデルを試してください。',
        needsSettings: false,
      }
    }
    if (err.status === 503 || err.status === 529) {
      return {
        message:
          'モデルが混雑しています。しばらく待ってから再送信するか、別のモデルを試してください。',
        needsSettings: false,
      }
    }
    if (err.status === 0) {
      return { message: err.message, needsSettings: false }
    }
    return { message: `${label}エラー (${err.status}): ${err.message}`, needsSettings: false }
  }

  console.error(err)
  return { message: '予期しないエラーが発生しました。', needsSettings: false }
}
